import {useEffect, useState} from "react"
import {Alert, Card, Spinner, Tab, Tabs} from "react-bootstrap"
import {useSearchParams} from "react-router-dom"
import {useTranslation} from "react-i18next"
import {useAuth} from "../../context/AuthProvider"
import {EexamMeta} from "./types"
import {loadEexamMeta} from "./api/eexam.api"
import EexamManagement from "./EexamManagement"
import ExamAidManagement from "./ExamAidManagement"
import ExamPeriodManagement from "./ExamPeriodManagement"
import ExamRunManagement from "./ExamRunManagement"
import PageHeader from "../Navigation/PageHeader"

export default function EexamAdminView() {
    const auth = useAuth()
    const [searchParams, setSearchParams] = useSearchParams()
    const {t} = useTranslation(["eexam"])
    const [meta, setMeta] = useState<EexamMeta | null>(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<string | null>(null)

    const loadMeta = async () => {
        setLoading(true)
        setError(null)
        try { setMeta(await loadEexamMeta(auth.axiosAuthHeader())) } catch { setError(t("messages.loadError")) } finally { setLoading(false) }
    }

    useEffect(() => { loadMeta() }, [])

    if (loading) return <Card><Card.Body className="d-flex align-items-center gap-2"><Spinner animation="border" size="sm"/>{t("messages.loading")}</Card.Body></Card>
    if (error || !meta) return <Alert variant="danger">{error ?? t("messages.loadError")}</Alert>

    const activeTab = searchParams.get("tab") ?? "runs"

    return (
        <div className="component">
            <PageHeader
                title={t("page.title")}
                icon="bi-display"
                breadcrumbs={[
                    {label: "Arbeitsbereich"},
                    {label: t("page.title")},
                ]}
            />
            {!meta.canWrite && <Alert variant="info">{t("messages.readOnly")}</Alert>}
            <Tabs activeKey={activeTab} className="mb-3"
                onSelect={key => {
                    if (!key) return
                    const next = new URLSearchParams(searchParams)
                    next.set("tab", key)
                    setSearchParams(next)
                }}>
                <Tab eventKey="runs" title={t("run.title")}><ExamRunManagement meta={meta} canWrite={meta.canWrite} onMetaChanged={loadMeta}/></Tab>
                <Tab eventKey="eexams" title={t("eexam.title")}><EexamManagement canWrite={meta.canWrite}/></Tab>
                <Tab eventKey="aids" title={t("aid.title")}><ExamAidManagement canWrite={meta.canWrite}/></Tab>
                <Tab eventKey="periods" title={t("period.title")}><ExamPeriodManagement canWrite={meta.canWrite}/></Tab>
            </Tabs>
        </div>
    )
}
